import { onDomReady } from './helpers';

import { initMobileMenu, initStickyMenu } from './components/menu';

onDomReady(() => {
    initMobileMenu();
    initStickyMenu();
});
